import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import { Computer } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'

const Windoge2Modal = ({ close, modalStyle, frameStyle, bulletStyle }) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: isMobile ? 8 : 250, y: isMobile ? 8 : 200 }}
      icon={<Computer variant="16x16_4" />}
      title="Windoge95 Version 2"
      closeModal={close}
      buttons={[{ value: 'Ok', onClick: close }]}
      style={modalStyle}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Windoge95 Version 2`)}
        </Heading>

        <Text fontSize="18px">
          {t(
            `We have redesigned and rebuilt Windoge95 from the ground up. The token has been re-engineered for better stability and efficiency long term, and the team has learned a great deal from the launch of V1 two months ago.`,
          )}
        </Text>
        <Text fontSize="18px" my="16px">
          {t(
            `Windoge95 has always been about nostalgia and comfort, but that doesn't mean we can't add some shiny new features in V2. Windoge95 V2 is now a reflection token, rather than a rewards token which makes for much more stable buy and sell pressure. `,
          )}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `Additionally, we have re-built the web application to be more user friendly and more intuitive, while leaning even further into the nostalgic look and feel of Windoge95. We have also added a raft of new features to the website, including a native swap, as well as an NFT Creation studio.`,
          )}
        </Text>
        <Text fontSize="18px">
          {t(
            `The features the community loved from V1 have been migrated to V2, including the diverse library of games available right in your browser. We will continue to build out this games library, as well as use them for community engagement + competitions over the life of the token.`,
          )}
        </Text>

        <img
          src="https://i.pinimg.com/originals/97/35/10/9735102350e3656a972e1f82dfd334a9.gif"
          alt="Start button gif"
          style={{
            height: '50%',
            minHeight: '150px',
            maxHeight: '250px',
            margin: '16px 0px',
            borderRadius: '8px',
          }}
        />

        <Text fontSize="18px" mb="24px">
          {t(`V2 website features include:`)}
        </Text>
        <ul>
          <li style={bulletStyle}>
            {t(`WindogeSwap, a fully featured trading platform for freely exchanging WNDG95, DOGE rewards, BNB,
                  NFTs, and more`)}
          </li>
          <li style={bulletStyle}>
            {t(
              `NFT Creator, where our community can easily create and mint NFTs on Binance Smart chain within a friendly, MS Paint-style interface`,
            )}
          </li>
          <li style={bulletStyle}>
            {t(
              `Private Arcade, featuring classic games and high score contests with rewards, exclusively available to Windoge95 holders`,
            )}
          </li>
        </ul>
        <Text fontSize="18px">
          {t(`Click through the rest of the desktop icons to learn more about Windoge95 V2!`)}
        </Text>
      </Frame>
    </Modal>
  )
}

export default Windoge2Modal
